'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { PatientSelectionModalKeys } from '@/app/(main)/_components/patient-selection/_types/patient-selection-modal-keys.enum';
import { ModalCloseButton } from '@/components/ui/modal-close-button/modal-close-button.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { useProgressiveModal } from '@/components/ui/progressive-modal/progressive-modal.hook';
import { DependentForm } from '@/app/(main)/(pages)/(auth)/dependentes/_components/dependent-form.component';

export function PatientSelectionCreate() {
  const { handleJump, onClose } = useProgressiveModal<PatientSelectionModalKeys>();
  const backToList = () => handleJump({ key: PatientSelectionModalKeys.LIST, returning: true });

  return (
    <div className="flex flex-col gap-3 p-5" data-testid={DataTestIdEnum.PATIENT_SELECTION_CREATE_STEP}>
      <div className="flex items-start justify-between gap-2">
        <Typography variant={TypographyVariant.MODAL_TITLE}>Criar dependente</Typography>
        <ModalCloseButton
          label="Fechar modal"
          data-testid={DataTestIdEnum.PATIENT_SELECTION_CREATE_STEP_CLOSE_BUTTON}
          className="shrink-0"
          onClick={onClose}
        />
      </div>
      <DependentForm onSuccessCallback={backToList} onBack={backToList} />
    </div>
  );
}
